import styles from "./table.module.css";

export default function TableHeader({ children }) {
    return (
      <thead className={styles.thead}>
        {children}
      </thead>
    )
}